import { createContext, useContext } from 'react'

import { assertDefinedAndNotNull } from '@orus.eu/error'
import { Dialog } from '@orus.eu/pharaoh-next/components/patterns/dialog'

type HelpContactContextValue = {
  open: boolean
  handle: ReturnType<typeof Dialog.createHandle>
  openHelpContact: () => void
}

export const HelpContactContext = createContext<HelpContactContextValue | undefined>(undefined)

export function useIsHelpContactOpen(): boolean {
  const context = assertDefinedAndNotNull(
    useContext(HelpContactContext),
    'Cannot read help contact visibility outside HelpContact.Root',
    { hook: 'useIsHelpContactOpen' },
  )
  return context.open
}

export function useOpenHelpContact(): () => void {
  const context = useContext(HelpContactContext)
  if (context === undefined) {
    throw new Error('useOpenHelpContact must be used within HelpContact.Root')
  }
  return context.openHelpContact
}

export function useOptionalOpenHelpContact(): (() => void) | undefined {
  return useContext(HelpContactContext)?.openHelpContact
}
